import React, { ReactNode, useState } from 'react';

import { ChevronDownMini } from '@xsolla/ui-icons';

import { VerticalCenterBlock } from '../../../styled';
import { CollapseWithTitleWrapper, InstructionTitle, InstructionWrapper } from './styled';

type Props = {
  title: ReactNode;
  instruction: ReactNode;
};

const CollapseWithTitle = ({ title, instruction }: Props): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  return (
    <CollapseWithTitleWrapper collapsed={isCollapsed}>
      <VerticalCenterBlock
        onClick={() => setIsCollapsed((prev) => !prev)}
        style={{ cursor: 'pointer' }}>
        <ChevronDownMini />
        <InstructionTitle>{title}</InstructionTitle>
      </VerticalCenterBlock>
      <InstructionWrapper collapsed={isCollapsed}>{instruction}</InstructionWrapper>
    </CollapseWithTitleWrapper>
  );
};

export default CollapseWithTitle;
